import React from 'react';
import { Outlet } from 'react-router-dom';
import SubMenuNavigator from '../../component/Common/Router/App/Common/SubMenuNavigator';
import { PAGE_SAFETY } from '../../constant/Common/Router/App/Common/mapper';

const Safety = () => {
  return (
    <div className="w-full flex flex-col">
      <SubMenuNavigator page={PAGE_SAFETY} />
      <Outlet />
    </div>
  );
};

export default Safety;
